<template>
    <div >
        <h3 class="mb-2">Thank you. You have successfully registered.</h3>
        <div class="card mb-3">
            <div class="card-body">
                <div class="badge rounded bg-light text-dark" style="font-size: xx-small;">{{ transaction.EventID }}</div>
                <h5 class="card-title">{{ transaction.EventName }}</h5>
                
                <div class="card-text">
                    <pre-formatted :content="transaction.EventDesc"></pre-formatted>
                </div>

                <div v-if="transaction.ContactHours">
                    <h6 class="card-title mb-0 mt-3">Contact Hours</h6>
                    <div class="card-text" v-html="transaction.ContactHours"></div>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-body">
                <h6 class="card-title mb-0">Location</h6>
                <div class="card-text">
                    <a :href="`/location/${transaction.LocationGUID}`"><i class="far fa-map me-2"></i>{{ transaction.LocationName }}</a>
                </div>
                <h6 class="card-title mb-0 mt-3">Start Time</h6>
                <div class="card-text" v-html="`<i class='far fa-clock me-2'></i>${transaction.EventStart}`"></div>
                
                <h6 class="card-title mb-0 mt-3">End Time</h6>
                <div class="card-text" v-html="`<i class='far fa-clock me-2'></i>${transaction.EventEnd}`"></div>

                <h6 class="card-title mb-0 mt-3">Contact</h6>
                <div class="card-text">
                    <a :href="`mailto:${transaction.EventContactEmail}`"><i class="far fa-envelope me-2"></i>{{ transaction.EventContactName }}</a>
                </div>
            </div>
        </div>

        <div v-if="transaction.GraduateCreditAccepted" class="card mb-3">
            <div class="card-body">
                <h6 class="card-title mb-0">Grad Credit</h6>
                <div class="card-text">{{ transaction.GraduateCreditAvailable }}</div>

                <h6 class="card-title mb-0 mt-3">Grad School</h6>
                <div class="card-text" v-html="transaction.GraduateSchool"></div>
                
                <h6 class="card-title mb-0 mt-3">Grad Instructions</h6>
                <div class="card-text">
                    <pre-formatted :content="transaction.GraduateDirections"></pre-formatted>
                </div>

                <h6 class="card-title mb-0 mt-3">Contact Hours</h6>
                <div class="card-text">
                    <a :href="`mailto:${transaction.EventContactEmail}`"><i class="far fa-envelope me-2"></i>{{ transaction.EventContactName }}</a>
                </div>
            </div>
        </div>

        <div v-if="transaction.OnlineEventURL" class="card mb-3">
            <div class="card-body">
                <h6 class="card-title mb-0">Online Event Id</h6>
                <div class="card-text">{{ transaction.OnlineEventID }}</div>

                <h6 class="card-title mb-0 mt-3">Online Instructions</h6>
                <div class="card-text">
                    <pre-formatted :content="transaction.OnlineEventInstructions"></pre-formatted>
                </div>
                
                <h6 class="card-title mb-0 mt-3">Online Event URL</h6>
                <div class="card-text">
                    <a :href="transaction.OnlineEventURL" target="_blank">{{ transaction.OnlineEventURL }}</a>
                </div>

                <h6 class="card-title mb-0 mt-3">Contact Hours</h6>
                <div class="card-text">
                    <a :href="`mailto:${transaction.EventContactEmail}`"><i class="far fa-envelope me-2"></i>{{ transaction.EventContactName }}</a>
                </div>
            </div>
        </div>

        <div class="card mb-5">
            <div class="card-body">
                <h6 class="card-title mb-0">Event Fee</h6>
                <div class="card-text" v-html="money(transaction.Charged)"></div>

                <h6 class="card-title mb-0 mt-3">Payment Method</h6>
                <div class="card-text" v-html="paymentMethod"></div>

                <div v-if="transaction.PaymentMethod == 'aa'">
                    <h6 class="card-title mb-0 mt-3">Agreement Purpose</h6>
                    <div class="card-text" v-html="transaction.AaCodePurpose"></div>
                </div>

                <div v-if="transaction.PaymentMethod == 'po'">
                    <h6 class="card-title mb-0 mt-3">Purchase Order</h6>
                    <div class="card-text" v-html="transaction.PoNumber"></div>
                </div>

                <div v-if="transaction.PaymentMethod == 'check' || transaction.PaymentMethod == 'mo'">
                    <h6 class="card-title mb-0 mt-3">Payment Instructions</h6>
                    <div class="card-text">
                        <form-enrolled-pay-instructions></form-enrolled-pay-instructions>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PreFormatted from './PreFormatted.vue';
import FormEnrolledPayInstructions from './FormEnrolledPayInstructions.vue';

export default {
    components: { PreFormatted, FormEnrolledPayInstructions, },

    props: {
        transaction: {
            type: Object,
            default: function(data={}) {
                return data();
            },
        }
    },

    computed: {
        paymentMethod: function() {
            switch (this.transaction.PaymentMethod) {
                case 'cc': 
                    return '<i class="far fa-credit-card me-2"></i>Credit Card';

                case 'aa':
                    return '<i class="far fa-handshake me-2"></i>Agency Agreement';

                case 'po':
                    return '<i class="fas fa-file-contract me-2"></i>Purchase Order';
                
                case 'check':
                case 'mo':
                    return '<i class="fas fa-money-check me-2"></i>Personal Check / Money Order';
                
                default:
                    return 'Unknown';
            }
        },
    },

    methods: {
        money: function(value) {
            if (value === null) {
                return '<i class="fas fa-asterisk me-2 text-danger"></i>Special payment instructions. See event details for more information.';
            }

            value = value / 100;
            return `$${value.toFixed(2)}`;
        }
    },

    data() {
        return {};
    },
}
</script>